const APPEND_ONLY_CUSTOMER_TYPES = new Set(['charge', 'payment', 'allocation_sync']);

/**
 * Resuelve operationId para dedupe en cola y RPC.
 *
 * - Movimientos append-only (charge/payment/allocation_sync): clave ESTABLE por `movementId`
 *   (son eventos contables idempotentes; reaplicarlos sería duplicar dinero).
 * - Perfil del cliente (alta/edición/bloqueo): clave por COMANDO (`customerId` + versión). Si
 *   usáramos solo `customerId`, el servidor reclamaría esa clave en el alta y descartaría toda
 *   edición posterior como idempotente (`ops.try_claim_device_command`), por lo que los cambios
 *   nunca volverían a llegar al servidor. La versión (`updated_at`) hace único cada comando y
 *   deja que un reintento del mismo comando siga deduplicándose.
 */
export function resolveCustomerSyncOperationId(payload: Record<string, unknown>): string | undefined {
  const type = typeof payload.type === 'string' ? payload.type.trim() : '';
  if (APPEND_ONLY_CUSTOMER_TYPES.has(type)) {
    const movementId = typeof payload.movementId === 'string' ? payload.movementId.trim() : '';
    return movementId.length > 0 ? movementId : undefined;
  }
  const customerId = typeof payload.customerId === 'string' ? payload.customerId.trim() : '';
  if (customerId.length === 0) return undefined;
  const version =
    typeof payload.updated_at === 'string' && payload.updated_at.trim().length > 0
      ? payload.updated_at.trim()
      : typeof payload.updatedAt === 'string' && payload.updatedAt.trim().length > 0
        ? payload.updatedAt.trim()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${customerId}:${version}`;
}

/** Stamp para push web-ram / cola: el RPC exige operationId. */
export function withCustomerSyncOperationId(payload: Record<string, unknown>): Record<string, unknown> {
  const operationId = resolveCustomerSyncOperationId(payload) ?? '';
  return operationId ? { ...payload, operationId } : payload;
}

export function isCustomerAppendOnlySyncPayload(payload: Record<string, unknown>): boolean {
  const type = typeof payload.type === 'string' ? payload.type.trim() : '';
  return APPEND_ONLY_CUSTOMER_TYPES.has(type);
}
